/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React from "react";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@mui/material";

/**
 * LoadingBackdrop - Reusable loading overlay component
 * @param {boolean} open - Whether the backdrop is visible
 * @param {string} color - Color of the progress indicator (default: "inherit")
 */
export const LoadingBackdrop = ({ open, color = "inherit" }) => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
    open={open}
  >
    <CircularProgress color={color} />
  </Backdrop>
);

LoadingBackdrop.propTypes = {
  open: PropTypes.bool.isRequired,
  color: PropTypes.string,
};
